module.exports = __webpack_public_path__ + "static/media/nationalpark.0f45fc96.jpg";